
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 13.3473L5.72022 17.687C5.80033 17.7798 5.89005 17.8638 5.98789 17.9376C6.34754 18.2089 6.80017 18.3263 7.24631 18.264C7.69246 18.2017 8.09562 17.9648 8.3672 17.6054L18 4.84975L16.3005 4L6.81215 14.2021L3.5542 11.6478L2 13.3473ZM16 9C16 8.44772 16.4477 8 17 8H21C21.5523 8 22 8.44772 22 9C22 9.55228 21.5523 10 21 10H17C16.4477 10 16 9.55228 16 9ZM14 13C14 12.4477 14.4477 12 15 12H21C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14H15C14.4477 14 14 13.5523 14 13ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H21C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16H12Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiBatchConsentFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
